import { buildUrlForRoute } from '../../utils/routing';

const ListingPropertyLink = ({
  propertyId,
  title,
  onOpenListing,
  className = '',
  children
}) => {
  const label = children || String(title || 'View listing').trim() || 'View listing';
  if (!propertyId) {
    return <span className={className}>{label}</span>;
  }

  if (onOpenListing) {
    return (
      <button
        type="button"
        className={`listing-property-link${className ? ` ${className}` : ''}`}
        onClick={() => onOpenListing(propertyId)}
      >
        {label}
      </button>
    );
  }

  return (
    <a
      href={buildUrlForRoute('home', propertyId)}
      className={`listing-property-link${className ? ` ${className}` : ''}`}
    >
      {label}
    </a>
  );
};

export default ListingPropertyLink;
